import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="min-h-screen" style={{ background: "#f4f1ec" }}>
      <main className="mx-auto max-w-[640px] px-5 py-10 text-neutral-800">
        <h1 className="text-3xl font-semibold">Hound Club Terms</h1>
        <p className="mt-2 text-sm text-neutral-500">Last updated: 11 May 2026</p>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">1. The programme</h2>
          <p>
            Hound Club Paw Points ("Hound Club") is the loyalty programme operated by
            The Little Green Hound Pantry Ltd ("we", "us"), trading from Kensington, London.
            It is free to join and open to UK residents aged 18+.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">2. Earning points</h2>
          <p>
            You earn 1 point per £1 spent in store on qualifying purchases, rounded down
            to the nearest whole pound. Gift cards, deposits, and previous loyalty redemptions
            do not earn points. Points are credited to the email address registered on your pass.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">3. Rewards</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li>350 points = £10 off your next purchase</li>
            <li>850 points = £25 off your next purchase</li>
            <li>1,500 points = £50 off your next purchase</li>
          </ul>
          <p>
            Rewards are redeemed at the till by showing your pass. Rewards have no cash
            value, cannot be exchanged, and cannot be combined with other promotions
            unless explicitly stated.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">4. Your pass</h2>
          <p>
            Your Apple Wallet pass is personal and non-transferable. We may decline to
            apply points or rewards if we reasonably believe a pass is being misused.
            You can remove your pass at any time from Apple Wallet — this does not delete
            your account or balance.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">5. Changes & closure</h2>
          <p>
            We may update reward tiers, earn rates, or these terms with at least 30 days'
            notice via email or in store. We may close the programme with 60 days' notice,
            during which you can redeem your remaining balance.
          </p>
        </section>

        <section className="mt-6 space-y-3">
          <h2 className="text-lg font-semibold">6. Contact</h2>
          <p>
            Questions? Email{" "}
            <a className="underline" href="mailto:help@thelittlegreenhoundpantry.co.uk">
              help@thelittlegreenhoundpantry.co.uk
            </a>
            .
          </p>
        </section>

        <Link to="/" className="mt-8 inline-block underline">← Back to enrolment</Link>
      </main>
    </div>
  );
}
